import { createContext } from 'react';
import { CompanyResponse, CompanyUsageResponse, CurrentUserResponse, FeatureResponse } from '@demand-iq/user-sdk';

interface UserContext {
  user: CurrentUserResponse | null;
  company: CompanyResponse | null;
  setCompany: (company: CompanyResponse | null, navigateUrl?: string) => void;
  updateCompanyData: (company: CompanyResponse) => void;
  /** Company being spoofed, or null when the user is on their own company. */
  spoofedCompanyId: string | null;
  availableFeatures: FeatureResponse | null;
  planUsage: CompanyUsageResponse | null;
}

export const UserContext = createContext<UserContext>({
  user: null,
  company: null,

  setCompany: (_company: CompanyResponse | null, _navigateUrl?: string) => {},

  updateCompanyData: (_company: CompanyResponse) => {},
  spoofedCompanyId: null,
  availableFeatures: null,
  planUsage: null,
});
